import React from "react";
import * as MUI from "@material-ui/core";
import { useStyles } from "./styles";

export const BlockCardDescription = ({ children, ...props }) => {
  const classes = useStyles(props);
  const adapterTitle = {
    body1: classes.title,
  };
  const adapterDescription = {
    body1: classes.fontDescrition,
  };
  return (
    <div className={classes.description}>
      {children &&
        Array.isArray(children) &&
        children.map((node, ind) => {
          if (ind) {
            return (
              <MUI.Typography classes={adapterDescription} key={`descr_${ind}`}>
                {node}
              </MUI.Typography>
            );
          }
          return (
            <MUI.Typography classes={adapterTitle} key={`title_${ind}`}>
              {node}
            </MUI.Typography>
          );
        })}
    </div>
  );
};
BlockCardDescription.muiName = "BlockCardDescription";
BlockCardDescription.displayName = "BlockCardDescription";
BlockCardDescription.defaultProps = {
  role: "title",
};
export default BlockCardDescription;
